import axios from "@app/Security/AxiosAuthentication";
import UpdateChartNotificationInterface from "@app/Interface/UpdateChartNotificationInterface";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class ChartNotificationHelper {

    static updateChartNotification = async (setting: UpdateChartNotificationInterface): Promise<boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.CHART_NOTIFICATION_SETTING;

        const url = baseUrl + endPoint;

        const options = {
            withCredentials: true,
        };

        try {

            axios.post(url, setting, options)

            return true;

        } catch (error) {

            RollbarHelper.logRequestError(error, "updateChartNotification()");

            return false;

        }

    }

}